<script setup lang="ts">
type Variant = 'default' | 'large' | 'small' | 'modal';
type Tag = 'h1' | 'h2' | 'h3' | 'h4';
const props = defineProps({
  tag: {
    type: String as PropType<Tag>,
    required: true,
  },
  variant: {
    type: String as PropType<Variant>,
    default: 'default',
  },
  anchor: {
    type: String as PropType<string>,
    default: undefined,
  },
});

const VARIANT_CLASSES: Record<Tag, Record<Variant, string>> = {
  h1: {
    default: 'flex text-4xl mt-8 mb-4',
    modal: 'flex text-4xl mt-4 mb-4',
    large: 'text-4xl',
    small: 'text-sm',
  },
  h2: {
    default: 'flex mb-2 text-2xl text-neutral',
    modal: 'flex mb-2 text-2xl text-gray-900 dark:text-white',
    large: 'text-2xl',
    small: 'text-lg',
  },
  h3: {
    default: 'mb-2 text-xl',
    modal: 'mb-2 text-xl',
    large: 'text-2xl',
    small: 'text-md',
  },
  h4: {
    default: 'mb-2 text-sm font-bold',
    modal: 'mb-2 text-sm font-bold',
    large: 'text-2xl',
    small: 'text-sm',
  },
};

const variantClasses = computed(() => {
  return VARIANT_CLASSES[props.tag][props.variant];
});
</script>

<template>
  <component :is="tag" :id="props.anchor" :class="variantClasses" class="flex justify-between items-center">
    <slot></slot>
    <div class="align-bottom">
      <slot name="trailing" class="align-bottom" />
    </div>
  </component>
</template>
<style scoped></style>
